import { FormattedMessage, useIntl } from 'react-intl'
import {
  Divisor,
  InfoItem,
  InfoItemContainer,
  InfoLabel,
  InfoValueDescription,
  ProjectDetailsInfoContainer,
  ReadMore
} from '../../styled-components'

import { DateTime } from 'luxon'
import { useEffect, useRef, useState } from 'react'
import DetailsInfoItem from './details-info-item'

const ProjectInfoPanelInfo = ({ projectDetails }) => {
  const { formatMessage } = useIntl()
  const descriptionRef = useRef(null)
  const [isExpanded, setIsExpanded] = useState(false)
  const [isTruncated, setIsTruncated] = useState(false)

  const { address, initials, description } = projectDetails
  const { cc, city, streetAddress } = address

  const projectAddress = [streetAddress, city, cc].filter(Boolean).join(', ')

  const formatDate = (date) => {
    if (date) {
      return DateTime.fromISO(date).toFormat('dd MMMM yyyy')
    }

    return null
  }

  const startDate = formatDate(projectDetails?.duration?.start)
  const endDate = formatDate(projectDetails?.duration?.end)

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded)
  }

  useEffect(() => {
    const el = descriptionRef.current

    if (!el) return

    const checkTruncation = () => {
      setIsTruncated(el.scrollHeight > el.clientHeight)
    }

    checkTruncation()
  }, [description])

  return (
    <ProjectDetailsInfoContainer>
      <InfoItemContainer>
        <DetailsInfoItem
          label={formatMessage({ id: 'location' })}
          value={projectAddress || '-'}
        />
        <DetailsInfoItem label={'ID'} value={initials || '-'} />
        <DetailsInfoItem
          label={formatMessage({ id: 'start_date' })}
          value={startDate || '-'}
        />
        <DetailsInfoItem
          label={formatMessage({ id: 'end_date' })}
          value={endDate || '-'}
        />
      </InfoItemContainer>
      <Divisor />
      <InfoItemContainer>
        <InfoItem>
          <InfoLabel>
            <FormattedMessage id="description" />
          </InfoLabel>
          <InfoValueDescription ref={descriptionRef} isExpanded={isExpanded}>
            {description || '-'}
          </InfoValueDescription>
          {isTruncated && (
            <ReadMore onClick={toggleExpanded}>
              <FormattedMessage id={isExpanded ? 'less' : 'more'} />
            </ReadMore>
          )}
        </InfoItem>
      </InfoItemContainer>
    </ProjectDetailsInfoContainer>
  )
}

export default ProjectInfoPanelInfo
